import { useContext } from 'react';

import LeftDrawerContext from './LeftDrawerContext';

export default function useLeftDrawerContext() {
  return useContext(LeftDrawerContext);
}
